module.exports = "<a class=\"tableGridIconExtendedCell\">\n  <span class=\"tableGridExtendedCell__icon\" ng-if=\"vm.icon\" uib-tooltip=\"{{vm.icon.tooltipText}}\">\n    <span class=\"icon\" aria-hidden=\"true\" ng-class=\"vm.icon.class\"></span>\n\t<span class=\"sr-only\">{{::vm.icon.class}}</span>\n  </span>\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/tableGridIconExtendedCell/tableGridIconExtendedCell.html
// module id = 585
// module chunks = 1